<template>

        <md-card>
          <!-- <md-card-header class="md-card-header-icon">
            <div class="card-icon">
              <md-icon>design_services</md-icon>
            </div>
            <h4 class="title">
              Service Information
            </h4>
          </md-card-header> -->
          <md-card-content>

            <div class="md-layout">
              <div class="md-layout-item md-size-50 md-small-size-100">
                <validation-provider rules="name" ref="driver_name" v-slot="{ errors }">
                <md-field class="md-invalid">
                    <label for="">Driver Name</label>
                  <md-input v-model="driver.driver_name" required/>
                  <validation-error :errors="apiValidationErrors.driver_name" />
                <span class="md-error">{{ errors[0] }}</span>
                </md-field>
                </validation-provider>
              </div>

              <div class="md-layout-item md-size-50 md-small-size-100">
                <validation-provider rules="placeofbirth" ref="driver_place_of_birth" v-slot="{ errors }">
                <md-field class="md-invalid">
                    <label for="">Place of Birth</label>
                  <md-input  v-model="driver_place_of_birth_text" readonly/>
                  <md-button class="md-icon-button md-info md-dense md-round" v-on:click="findDriverPlace">
                    <md-icon >search</md-icon>
                  </md-button>
                  <validation-error :errors="apiValidationErrors.driver_place_of_birth" />
                <span class="md-error">{{ errors[0] }}</span>
                </md-field>
                </validation-provider>
              </div>
              
              
            </div>

            <div class="md-layout">
              <div class="md-layout-item md-size-50 md-small-size-100" style="margin-top:35px;">
                <validation-provider rules="nickname" ref="driver_nickname" v-slot="{ errors }">
                <md-field class="md-invalid">
                    <label for="">Nickname</label>
                  <md-input  v-model="driver.driver_nickname" />
                  <validation-error :errors="apiValidationErrors.driver_nickname" />
                <span class="md-error">{{ errors[0] }}</span>
                </md-field>
                </validation-provider>
              </div>
              <div class="md-layout-item md-size-50 md-small-size-100">
                <validation-provider rules="dateofbirth" ref="driver_date_of_birth" v-slot="{ errors }">
                <label class="md-layout-item md-size-15 md-form-label">Date of Birth</label>
                <md-field class="md-invalid">
                  <md-input type="date" v-model="driver.driver_date_of_birth" />
                  <validation-error :errors="apiValidationErrors.driver_date_of_birth" />
                <span class="md-error">{{ errors[0] }}</span>
                </md-field>
                </validation-provider>
              </div>
            </div>

            <div class="md-layout">
              <div class="md-layout-item md-size-50 md-small-size-100" style="margin-bottom:20px;">
                <validation-provider v-slot="{ errors }">
                <md-field class="md-invalid">
                    <label for="">Driver Address</label>
                    <md-textarea v-model="driver.driver_address" maxlength="200" md-autogrow></md-textarea>
                    <!-- <md-avatar >
                  <md-icon style="color:blue;">report</md-icon>
                  <md-tooltip md-direction="left">You can enter to add new row</md-tooltip>
                </md-avatar> -->
                  <validation-error :errors="apiValidationErrors.driver_address" />
                <span class="md-error">{{ errors[0] }}</span>
                </md-field>
                </validation-provider>
              </div>

              <div class="md-layout-item md-size-50 md-small-size-100">
                <validation-provider rules="gender" ref="driver_gender" v-slot="{ errors }">
                <md-field class="md-invalid">
                    <label for="">Gender</label>
                  <md-select v-model="driver.driver_gender" required>
                      <md-option value="0">Pria</md-option>
                      <md-option value="1">Perempuan</md-option>
                      <md-option value="2">Lainnya</md-option>
                  </md-select>
                  <validation-error :errors="apiValidationErrors.driver_gender" />
                <span class="md-error">{{ errors[0] }}</span>
                </md-field>
                </validation-provider>
              </div>
            </div>

            <div class="md-layout">
              <div class="md-layout-item md-size-50 md-small-size-100">
                <validation-provider name="email" rules="required|email" ref="driver_email" v-slot="{ errors }">
                <md-field class="md-invalid">
                    <label for="">Driver Email</label>
                  <md-input for="email" type="email"  v-model="driver.driver_email"/>
                  <validation-error :errors="apiValidationErrors.driver_email" />
                <span class="md-error">{{ errors[0] }}</span>
                <!-- <span class="md-error" v-if="msg.email">{{ msg.email }}</span> -->
                
                </md-field>
                </validation-provider>
              </div>

              <div class="md-layout-item md-size-50 md-small-size-100">
                <validation-provider v-slot="{ errors }">
                <md-field class="md-invalid" >
                    <label for="">Driver Blood Type</label>
                    <md-select  v-model="driver.driver_blood_type" >
                      <md-option value="0">A</md-option>
                      <md-option value="1">B</md-option>
                      <md-option value="2">AB</md-option>
                      <md-option value="3">O</md-option>
                  </md-select>
                  <validation-error :errors="apiValidationErrors.driver_blood_type" />
                <span class="md-error">{{ errors[0] }}</span>
                </md-field>
                </validation-provider>
              </div>
              
            </div>

            <div class="md-layout">
              <div class="md-layout-item">
                <validation-provider rules="driverdp" ref="driver_dp_id" v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Registration Fee</label>
                  <md-input v-model="driver_dp_text" required readonly/>
                  <validation-error :errors="apiValidationErrors.driver_dp_id" />
                  <md-button class="md-icon-button md-info md-dense md-round" v-on:click="findDriverDp">
                    <md-icon >search</md-icon>
                  </md-button>
                <span class="md-error">{{ errors[0] }}</span>
                </md-field>
                </validation-provider>
              </div>

              <div class="md-layout-item md-size-50 md-small-size-100">
                <validation-provider  v-slot="{ errors }">
                <md-field class="md-invalid">
                    <label for="">Religion</label>
                    <md-select v-model="driver.driver_religion" >
                      <md-option value="1">Islam</md-option>
                      <md-option value="2">Kristen</md-option>
                      <md-option value="3">Katolik</md-option>
                      <md-option value="4">Budha</md-option>
                      <md-option value="5">Hindu</md-option>
                      <md-option value="6">Konghucu</md-option>
                      <md-option value="7">Lainnya</md-option>
                  </md-select>
                  <validation-error :errors="apiValidationErrors.driver_religion" />
                <span class="md-error">{{ errors[0] }}</span>
                </md-field>
                </validation-provider>
              </div>
            </div>

            <div class="md-layout">

              <div class="md-layout-item md-size-50 md-small-size-100">
                <validation-provider  v-slot="{ errors }">
                <md-field class="md-invalid">
                    <label for="">Last Education</label>
                    <md-select v-model="driver.driver_last_education" >
                      <md-option value="0">SD</md-option>
                      <md-option value="1">SMP</md-option>
                      <md-option value="2">SMA/SMK</md-option>
                      <md-option value="3">Universitas</md-option>
                      <md-option value="4">Lainnya</md-option>
                  </md-select>
                  <validation-error :errors="apiValidationErrors.driver_last_education" />
                <span class="md-error">{{ errors[0] }}</span>
                </md-field>
                </validation-provider>
              </div>
              
              <div class="md-layout-item md-size-50 md-small-size-100">
                <validation-provider rules="pool" ref="driver_pool" v-slot="{ errors }">
                <md-field class="md-invalid">
                    <label for="">Pool</label>
                    <md-select v-model="driver.driver_pool" required>
                    <md-option v-for="option in options_pool_list" :key="option.value" :value="option.id">
                      {{ option.pool_name }}
                    </md-option>
                  </md-select>
                  <validation-error :errors="apiValidationErrors.driver_pool" />
                <span class="md-error">{{ errors[0] }}</span>
                </md-field>
                </validation-provider>
              </div>
            </div>

            <div class="md-layout">
              <div class="md-layout-item md-size-50 md-small-size-100">
                <validation-provider rules="phone" ref="driver_phone_no" v-slot="{ errors }">
                <md-field class="md-invalid">
                    <label for="">Driver Phone</label>
                  <md-input type="text" v-on:keypress="NumbersOnly" v-model="driver.driver_phone_no" required/>
                  <validation-error :errors="apiValidationErrors.driver_phone_no" />
                <span class="md-error">{{ errors[0] }}</span>
                </md-field>
                </validation-provider>
              </div>
              <div class="md-layout-item md-size-50 md-small-size-100">
                <validation-provider rules="digits_between:10,14" v-slot="{ errors }">
                <md-field class="md-invalid">
                    <label for="">Driver Emergency Phone</label>
                  <md-input type="text" v-on:keypress="NumbersOnly" v-model="driver.driver_emergency_phone_no" />
                  <validation-error :errors="apiValidationErrors.driver_emergency_phone_no" />
                <span class="md-error">{{ errors[0] }}</span>
                </md-field>
                </validation-provider>
              </div>
            </div>

            <div class="md-layout">

              
              <div class="md-layout-item md-size-50 md-small-size-100">
                <validation-provider v-slot="{ errors }">
                <md-field class="md-invalid">
                    <label for="">Blacklist</label>
                    <md-select v-model="driver.driver_blacklist" >
                      <md-option value="0">Yes</md-option>
                      <md-option value="1">No</md-option>
                  </md-select>
                  <validation-error :errors="apiValidationErrors.driver_blacklist" />
                <span class="md-error">{{ errors[0] }}</span>
                </md-field>
                </validation-provider>
              </div>
              <div class="md-layout-item md-size-50 md-small-size-100">
                <validation-provider v-slot="{ errors }">
                <md-field class="md-invalid">
                    <label >Photo Driver</label>
                    <md-file
                    ref="check_in"
                    @change="on_change_photo_driver"
                    v-model="driver.name_photo_driver"
                    accept="image/jpeg,image/png"
                    />
                <span class="md-error">{{ errors[0] }}</span>
                </md-field>
                
                </validation-provider>
                <div class="border p-2 mt-3">
                    <template v-if="file_photo_driver">
                  <viewer :src="file_photo_driver.base64" class="pointer photo_list">

                    <img
                        v-if="
                        file_photo_driver.type === 'image/jpeg' ||
                        file_photo_driver.type === 'image/png'"
                        :src="file_photo_driver.base64"
                        class="img-fluid"
                        style="height:auto; max-width:400px;"
                    />
                  </viewer>
                    <p class="mb-0">
                        size: {{ (file_photo_driver.size / 1048576).toFixed(2) }}MB 
                    </p>
                    </template>
                    <template v-if="!file_photo_driver && driver.driver_photo">
                      <span style="color:green"
                        >Current Photo:
                      </span>
                      <!-- <img 
                          :src="driver.driver_photo"
                           style="height:auto; max-width:400px;"
                          class="img-fluid"
                        /> -->
                      <viewer class="pointer photo_list" :src="driver.driver_photo">
                                  <img :src="driver.driver_photo" alt="driver current photo" >
                      </viewer>
                  </template>
                </div>
              </div>

              
            
            </div>

            
              <!-- <div class="md-layout-item md-size-50 md-small-size-100">
                <validation-provider v-slot="{ errors }">
                <md-field class="md-invalid">
                    <label for="">Location</label>
                    <md-input v-model="driver_location_view"  readonly />
                      <md-button style="background-color:green;" class="md-icon-button md-info md-dense" v-on:click="findDriverLocation">
                        <md-icon >search</md-icon>
                      </md-button>
                  <validation-error :errors="apiValidationErrors.driver_location_id" />
                <span class="md-error">{{ errors[0] }}</span>
                </md-field>
                </validation-provider>
              </div> -->
              

              

            
          </md-card-content>
          <modal ref="modalListDriverBusinessUnit" class="coba">
            <template v-slot:header>
              <h3>List Business Unit</h3>
            </template>

            <template v-slot:body>
              <list-driver-business-unit :data_id="$refs.modalListDriverBusinessUnit.data"/>
            </template>
          </modal>
          <modal ref="modalListDriverPlace" class="coba">
            <template v-slot:header>
              <h3>List City</h3>
              <md-button class="md-icon-button md-dense md-round"  @click="closeCity()">
                    <md-icon >close</md-icon>
                  </md-button>
            </template>

            <template v-slot:body>
              <list-driver-city :data_id="$refs.modalListDriverPlace.data"/>
            </template>
          </modal>
          <modal ref="modalListDriverDp" class="coba">
            <template v-slot:header>
              <h3>List Down Payment</h3>
              <md-button class="md-icon-button md-dense md-round"  @click="closeDp()">
                    <md-icon >close</md-icon>
                  </md-button>
            </template>

            <template v-slot:body>
              <list-driver-dp :data_id="$refs.modalListDriverDp.data"/>
            </template>
          </modal>
        </md-card>  
</template>
<script>
import { ValidationError } from "@/components";
import formMixin from "@/mixins/form-mixin";
import { required, email } from 'vee-validate/dist/rules';
import { extend , validate, localize } from 'vee-validate';
import ListDriverDp from "@/pages/Dashboard/Fms/Driver/ComponentForm/Modal/ListDriverDp.vue";
import ListDriverBu from "@/pages/Dashboard/Fms/Driver/ComponentForm/Modal/ListDriverBusinessUnit.vue";
import ListDriverCity from "@/pages/Dashboard/Fms/Driver/ComponentForm/Modal/ListDriverCity.vue";
import en from "vee-validate/dist/locale/en.json";
import { Modal } from "@/components";
import { min, max, numeric } from "vee-validate/dist/rules";
import Swal from "sweetalert2";

// import  Autoextra  from 'vue-autoextra';
localize({
      en
  });

  extend("min", min);
  extend("max", max);
  extend("numeric", numeric);

// membuat input phone number dengan min dan max digit
  extend('digits_between', {
    async validate(value, { min, max }) {
          const res = await validate(value, `numeric|min:${min}|max:${max}`,)
              return res.valid;
    },
    params: ['min', 'max'],
    message: 'Phone must be between {min} and {max} digits'
  });

extend('name', {
  ...required,
  message: 'Driver Name Field is required'
  });
  extend('gender', {
  ...required,
  message: 'Gender Field is required'
  });
  extend('phone', {
  ...required,
  message: 'Phone Field is required'
  });
  extend('driverdp', {
  ...required,
  message: 'DP Field is required'
  });
  extend('placeofbirth', {
  ...required,
  message: 'Place of Birth Field is required'
  });
  extend('dateofbirth', {
  ...required,
  message: 'Date of Birth Field is required'
  });
  extend('nickname', {
  ...required,
  message: 'Nickname Field is required'
  });
  extend('pool', {
  ...required,
  message: 'Pool Field is required'
  });
  
  // extend('email', {
  // ...required,
  // message: 'email Field is required'
  // });

  extend('email', email);

// Override the default message.
extend('required', {
  ...required,
  message: 'Email field is required'
});

export default {
  name: "regis-card",

  props: ['driver'],

  components: { ValidationError, Modal , "list-driver-dp": ListDriverDp, "list-driver-business-unit": ListDriverBu, "list-driver-city": ListDriverCity},

  mixins: [formMixin],
 
  data: () => ({
      name_photo_driver:null,
      file_photo_driver:null,
      driver_location_view: null,
      driver_busniness_text: null,
      driver_dp_text:null,
      driver_place_of_birth_text: null,
      options_pool_list:null

  }),

  // watch: {
  //     email(value) {
  //       // binding this to the data value in the email input
  //       this.email = value;
  //       this.validateEmail(value);
  //     }
  //   },
  created() {
          this.getDataPool()
  },
  
  methods:{
    //fungsi saat pertamakali page di buka
    async getDataPool(){
        await this.$store.dispatch("workshop_pool/list")
        this.options_pool_list = await this.$store.getters["workshop_pool/list"];
        
     
    },

    // getData(){
    //   this.driver.driver_pool = this.driver.driver_pool.id;

    // },

      //ambil data dari parent, digunakan saat edit
      async getDataParent() { 
        this.driver_dp_text = this.driver.driver_dp.dp_type.dp_amount_name+"-"+this.driver.driver_dp.dp_type.dp_amount
        // this.driver_busniness_text = this.driver.driver_business_unit.business_unit_name
        this.driver_place_of_birth_text = this.driver.driver_place_of_birth.city_name
        // this.driver.driver_pool = this.driver.driver_pool.id

    
      },

      on_change_photo_driver: function(event) {
      var input = event.target;
      console.log(this.driver.file_photo_driver)
      if(!input.files[0] || (input.files[0].size / 1048576).toFixed(2) > 3){
          if(input.files[0]){
          this.sizeTobig(input.files[0].size) 
          }
          this.resetFile('photo_driver')
          this.name_photo_driver = null
          this.driver.file_photo_driver = null
          this.file_photo_driver = null
          
          console.log(this.driver.file_photo_driver)
          return
        }
      //check apakah data ada
      if (input.files) {
        var reader = new FileReader();
        //read file
        reader.onload = (e) => {
          //set array filedata
          const fileData = {
            name: input.files[0].name,
            size: input.files[0].size,
            lastModified: input.files[0].lastModified,
            lastModifiedDate: input.files[0].lastModifiedDate,
            type: input.files[0].type,
            base64: e.target.result,
          };
          //set var berdasarkan fildedata
          this.driver.file_photo_driver = fileData;
          this.file_photo_driver = fileData;
        };
        reader.readAsDataURL(input.files[0]);
      }
    },
    sizeTobig(size){
      Swal.fire({
          icon: 'error',
          title: 'File is to big ('+(size / 1048576).toFixed(2)+'MB)',
          text: 'Maximum attachment file size 3MB',
        })
    },

    NumbersOnly(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    //fungsi yang di panggil dari sisi parent untuk mengechek validasi form di child ini
   async validateForm() {
      // const driver_no = this.$refs['driver_no'];
      const driver_name = this.$refs['driver_name'];
      const driver_gender = this.$refs['driver_gender'];
      const driver_phone_no = this.$refs['driver_phone_no'];
      const driver_nickname = this.$refs['driver_nickname'];
      const driver_place_of_birth = this.$refs['driver_place_of_birth'];
      const driver_date_of_birth = this.$refs['driver_date_of_birth'];
      const driver_email = this.$refs['driver_email'];
      const driver_dp_id = this.$refs['driver_dp_id'];
      const driver_pool = this.$refs['driver_pool'];

    let result = []
      // result.push(
      //     await driver_no.validate().then(function(data){
      //     return data.valid
      //     })
      // )
     
      result.push(
        await driver_pool.validate().then(function(data){
          return data.valid
        })
      )
      result.push(
        await driver_email.validate().then(function(data){
          return data.valid
        })
      )
      result.push(
        await driver_dp_id.validate().then(function(data){
          return data.valid
        })
      )
      result.push(
        await driver_nickname.validate().then(function(data){
          return data.valid
        })
      )
      result.push(
        await driver_date_of_birth.validate().then(function(data){
          return data.valid
        })
      )
      result.push(
        await driver_place_of_birth.validate().then(function(data){
          return data.valid
        })
      ) 
      result.push(
        await driver_name.validate().then(function(data){
          return data.valid
        })
      )
      result.push(
        await driver_gender.validate().then(function(data){
          return data.valid
        })
      )
      result.push(
        await driver_phone_no.validate().then(function(data){
          return data.valid
        })
      )
      
      return result.every(Boolean)
    },

    // findDriverLocation(){
    //   this.$refs.modalListDriverLocation.openModal()
    // },

    // modalCloseListDriverLocation(data,category){
    //   console.log(data)
    //   if(data.id){
    //    this.driver.driver_location = data.id
    //    this.driver_location_view = category+' '+ data.location_name
    //   }
    //   this.$refs.modalListDriverLocation.closeModal()
    // },

    findDriverDp(){
      this.$refs.modalListDriverDp.openModal()
    },

    modalCloseListDriverDp(data){
      console.log(data)
      if(data.id){
       this.driver.driver_dp_id = data.id
       this.driver_dp_text = data.dp_amount_name+" - "+data.dp_amount
      }
      this.$refs.modalListDriverDp.closeModal()
    },

    findDriverBusinessUnit(){
      this.$refs.modalListDriverBusinessUnit.openModal()
    },

    findDriverPlace(){
      this.$refs.modalListDriverPlace.openModal()
    },

    modalCloseListDriverBusinessUnit(data){
      console.log(data)
      if(data.id){
       this.driver.driver_business_unit_id = data.id
       this.driver_busniness_text = data.business_unit_name
      }
      this.$refs.modalListDriverBusinessUnit.closeModal()
    },

    modalCloseListDriverPlace(data){
      console.log(data)
      if(data.id){
       this.driver.driver_place_of_birth_id = data.id
       this.driver_place_of_birth_text = data.city_name
      }
      this.$refs.modalListDriverPlace.closeModal()
    },

    closeCity(){
      this.$refs.modalListDriverPlace.closeModal();

    },

    closeDp(){
      this.$refs.modalListDriverDp.closeModal();

    },
    
    // focusNoEstimate(){
    //     // this.$refs.driver_no_input.$el.focus();
    //     this.$refs.driver_create_at_datetime_input.$el.focus();
      
    // },
    //fungsi untuk menghapus colum keluhan
    // deleteColumn(index){
    //     if (index > -1) {
    //        this.keluhan.splice(index, 1)
    //         var filtered = this.keluhan.filter(function (el) {
    //           return el != null;
    //         });
    //         this.keluhan = filtered;
    //     }
    //     console.log(this.keluhan);
        
    //   },
    //   getData() {
    //         this.$emit('data', this.keluhan)
    //     },
  },
};
</script>

<style lang="scss" scoped>

.photo_list{
    max-width: 50%;
    height: auto;
    display: block;
    /* margin-left: auto;
    margin-right: auto; */
}
.pointer {cursor: pointer;}


.coba{
  width:800px !important;
  margin: 50px auto !important;
  
  @media screen and (max-width: 992px) {
      width: 90% !important;
    }
}

.z-index{
  z-index: 520 !important;
}
</style>
